import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { Environment } from '@as-react/common-utils';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
export const useGlossary = () => {
    const { glossaryPath, servicesApiPrefixAemServices } = useAemConfig();
    const endpoint = Environment.isDevelopment() ? 'http://localhost:4502/' : servicesApiPrefixAemServices;
    return useQuery({
        queryKey: ['glossary', glossaryPath],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield axios.get(`${endpoint}services/public/glossary?site=${glossaryPath}`);
            if (typeof window !== 'undefined') {
                window.glossary = data;
            }
            return data;
        }),
        enabled: typeof window !== 'undefined' && !window.glossary,
    });
};
